import { reviewConstants } from '../redux-constants'

export function loadReviews(params) {
    return (dispatch, getState, { firestore }) => {
        dispatch(loadingReviewsProgress(params))

        //var coworkingsColl = firestore.collection('coworkings').get()

        const reviewsColl = firestore.collection(
            'coworkings/umbv0r8tl11YgaayVfI6/reviews'
        )

        reviewsColl
            .get()
            .then(querySnapshot => {
                querySnapshot.forEach(doc => {
                    const data = doc.data()
                    const id = doc.id

                    dispatch(
                        updateReviews({
                            id,
                            ...data,
                        })
                    )
                })

                //Dispatch All
                dispatch(loadingReviewsSuccess())
            })
            .catch(error => {
                console.log(error)
                dispatch(loadingReviewsError(error.message))
            })
    }
}

function loadingReviewsProgress(payload) {
    return {
        type: reviewConstants.LOADING_REVIEWS_REQUEST,
        payload,
    }
}

function loadingReviewsSuccess() {
    return {
        type: reviewConstants.LOADING_REVIEWS_DONE,
    }
}

function updateReviews(payload) {
    return {
        type: reviewConstants.UPDATE_REVIEWS,
        payload,
    }
}

function loadingReviewsError(payload) {
    return {
        type: reviewConstants.LOADING_REVIEWS_FAILURE,
        payload,
    }
}
